/**
 * Shared constants for FloatingPanel (plan section 15.4).
 * Defaults are neutral (they reproduce the legacy DiagnosticMapWindow shell);
 * the brain popover opts into its behaviour by spreading BRAIN_PANEL_PRESET.
 */

export const PANEL_STATES = Object.freeze({
  HIDDEN: "hidden",
  BUBBLE: "bubble",
  SMALL: "small",
  MAXIMISED: "maximised",
});

export const PANEL_ACTIONS = Object.freeze({
  SHOW: "show",
  HIDE: "hide",
  OPEN_BUBBLE: "open_bubble",
  MINIMISE: "minimise",
  MAXIMISE: "maximise",
  CLOSE: "close",
  ESCAPE: "escape",
});

// Same ladder as the old map window: above the results overlay (40), below
// the learning overlay (100) and toasts.
export const LAYER_Z = Object.freeze({
  [PANEL_STATES.SMALL]: 60,
  [PANEL_STATES.BUBBLE]: 70,
  [PANEL_STATES.MAXIMISED]: 80,
});
// Raise-on-focus never lets a panel climb into the next rung of the ladder.
export const MAX_RAISE_OFFSET = 9;

export const PLACEMENT = Object.freeze({
  // Legacy: CSS-anchored inside the parent until the first drag, then fixed.
  ANCHORED: "anchored",
  // Brain: fixed to the viewport from the start, first open at the top right.
  VIEWPORT: "viewport",
});

export const RESIZE_DIRECTIONS = Object.freeze({
  RIGHT: "right",
  BOTTOM: "bottom",
  CORNER: "corner",
});

export const LEGACY_MIN_SIZE = Object.freeze({ width: 320, height: 220 });
export const LEGACY_ANCHOR = Object.freeze({ top: 12, right: 12 });
export const LEGACY_DEFAULT_SIZE = Object.freeze({
  width: "min(620px, calc(100% - 24px))",
  height: "min(430px, calc(100% - 24px))",
});

export const KEYBOARD_STEP_PX = 8;
export const BRAIN_STORAGE_PREFIX = "d5.brain.v1:";
export const BRAIN_NARROW_BREAKPOINT_PX = 900;
export const BRAIN_VIEWPORT_MARGIN_PX = 24;
export const BRAIN_DEFAULT_SIZE = Object.freeze({ width: 520, height: 460 });
export const BRAIN_MIN_SIZE = Object.freeze({ width: 360, height: 280 });
// The panel never covers the dashboard's top bars: the copilot header row
// (Export/Context/Learning/Feedback/avatar) and the action bar (Bugs/Cases).
export const BRAIN_AVOID_SELECTOR = ".d5-copilot-header, .d5-action-bar";
export const BRAIN_HEADER_GAP_PX = 10;

/** Props the brain popover spreads onto FloatingPanel (F2 onward). */
export const BRAIN_PANEL_PRESET = Object.freeze({
  className: "d5-brain-frame",
  placement: PLACEMENT.VIEWPORT,
  defaultSize: BRAIN_DEFAULT_SIZE,
  minSize: BRAIN_MIN_SIZE,
  viewportMargin: BRAIN_VIEWPORT_MARGIN_PX,
  avoidSelector: BRAIN_AVOID_SELECTOR,
  avoidGap: BRAIN_HEADER_GAP_PX,
  keyboardControls: true,
  trapFocusWhenMaximised: true,
  raiseOnFocus: true,
  narrowBreakpoint: BRAIN_NARROW_BREAKPOINT_PX,
  bubbleName: "diagnosis",
});
